import WhatWeBelieve from './WhatWeBelieve';
export default WhatWeBelieve;
